import { Text } from '@wartek-id/text-v1'

import Before2025 from 'app/KinerjaShared/components/Before2025'
import CardPeriodType from 'app/KinerjaShared/components/CardPeriodType'
import { assetUrl } from 'utils/url'

type CardHeaderProps = {
  isLocked?: boolean
}

export const ILLUSTRATION_LOCKED_PATH = assetUrl(
  '/illustrations/img-padlock-lock-failed-access.png'
)
export const ILLUSTRATION_UNLOCKED_PATH = assetUrl(
  '/illustrations/img-assessment-indicator.png'
)

export function CardHeader({ isLocked = false }: CardHeaderProps) {
  return (
    <section className="flex space-x-6 p-6 items-start">
      <div className="flex-shrink-0">
        <img
          alt=""
          src={isLocked ? ILLUSTRATION_LOCKED_PATH : ILLUSTRATION_UNLOCKED_PATH}
          width={84}
          height={84}
        />
      </div>

      <Before2025
        childrenFallback={
          <div className="max-w-3xl flex flex-col gap-1 self-stretch justify-center">
            <Text variant="heading-lg" as="h3">
              Pelaksanaan Kinerja
            </Text>
            <Text color="subdued">
              Laksanakan berdasarkan Perencanaan Anda.
            </Text>
          </div>
        }
      >
        <div className="space-y-1 max-w-2xl">
          <Text variant="subheading" className="!text-blue-60 uppercase">
            <CardPeriodType withDate type="pelaksanaan" />
          </Text>
          <Text variant="heading-lg">Pelaksanaan Kinerja</Text>
          <Text color="subdued">
            Berdasarkan perencanaan Anda, laksanakan Praktik Kinerja dan
            kumpulkan dokumen yang dibutuhkan.
          </Text>
        </div>
      </Before2025>
    </section>
  )
}
